import { OrderActionTypes } from "./order.types";

const INITIAL_STATE = {
  isAddOrderPending: false,
  addedOrder: null,
  addOrderError: null,
  order: {},
};

const OrderReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case OrderActionTypes.ADD.ORDER_PENDING:
      return {
        ...state,
        isAddOrderPending: true,
        addedOrder: false,
      };

    case OrderActionTypes.ADD.ORDER_SUCCESS:
      return {
        ...state,
        isAddOrderPending: false,
        addedOrder: true,
        addOrderError: null,
      };

    case OrderActionTypes.ADD.ORDER_ERROR:
      return {
        ...state,
        addedOrder: null,
        isAddOrderPending: false,
        addOrderError: action.payload,
      };

    case OrderActionTypes.SAVE:
      return {
        ...state,
        order: action.payload,
      };

    case OrderActionTypes.RESET.ORDER_ADD:
      return {
        ...state,
        addedOrder: null,
      };

    default:
      return state;
  }
};

export default OrderReducer;
